import Space from 'antd/lib/space';
import Tag from 'antd/lib/tag';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../reducers/reducers';
import { FilterType, shortDescriptionForFilter } from '../../types/filters';
import { ReleaseComponentProps } from '../../typescriptHelpers';
import { MY_VCS_USERNAME_TICKET_OWNER, selectAppliedFilters } from '../../selectors/memoizedSelectors';
import { removeFeatureItemsFilter, updateShowFixesOnly } from '../../actions/filters';
import { selectUser } from '@/selectors/selectors';
import { globalMessage } from '@/utils/globalMessage';

interface AppliedFiltersProps extends ReleaseComponentProps {
    useWorkingBranch: boolean;
}

const AppliedFilters: React.FC<AppliedFiltersProps> = (props) => {
    const appliedFilters = useSelector((state: RootState) => selectAppliedFilters(state));
    const dispatch = useDispatch();

    const user = useSelector(selectUser);
    const vcsUsers = Object.values(user.vcsUserDataByProvider ?? {}).map((vcsUserData) => vcsUserData.username);

    React.useEffect(() => {
        if (
            appliedFilters.some(
                (filter) => filter.type === FilterType.CodeAuthor && filter.codeAuthor === MY_VCS_USERNAME_TICKET_OWNER,
            ) &&
            vcsUsers.length === 0
        ) {
            globalMessage.warning(
                'You have a filter to only show items authored by you, but we could not find any associated VCS users.',
            );
        }
    }, []);

    const removeFilter = (index: number) => {
        const filterToRemove = appliedFilters[index];

        dispatch(removeFeatureItemsFilter(filterToRemove));

        if (filterToRemove.type === (FilterType.ShowFixesOnly as FilterType.ShowFixesOnly)) {
            dispatch(updateShowFixesOnly(false));
        }
    };

    return (
        <Space wrap size="small" style={{ marginTop: 10, marginBottom: 10 }}>
            {appliedFilters.map((filter, index) => {
                return (
                    <Tag closable onClose={() => removeFilter(index)} key={JSON.stringify(filter)}>
                        {shortDescriptionForFilter(filter, props.useWorkingBranch, vcsUsers)}
                    </Tag>
                );
            })}
        </Space>
    );
};

export default AppliedFilters;
